export default {
  select:
    'id,name,status,created,currentActionInstanceId,RejectedReason,RejectedDate,CancellationReason,CancellationDate,StartedMode,VoidedReason,VoidedDate,applicantUserEmail,errorDate,errorMessage,hasGeneratedDocuments',
  expand: {
    applicantUser: {
      select: 'id,fullName',
      expand: {
        position: { select: 'name' },
      },
    },
    process: {
      select: 'id,name,description,commentsAccessMode,isNotificationsEnabled',
      expand: {
        processGroup: { select: 'name' },
        forms: { select: 'id,name' },
        forms: { filter: 'isVisibleInDetails eq true' },
        variables: { select: 'id,internalName,type,initialValue' },
        actions: { select: 'id,type' },
        actions: { filter: `type eq Automy.Core.Enums.ActionType'SendEmail'` },
      },
    },
    actionInstances: {
      select:
        'id,created,status,rejectionReason,approvalRemarks,scheduledExecutionDateTime,finishedDateTime,executionOrder,overdueDateTime,observations',
      expand: {
        action: {
          select: 'id,type,displayTitle',
          expand: {
            webApiConnection: { select: 'name,method' },
            sequence: { select: 'id,name,pattern' },
            integration: { select: 'id,name' },
            integrationFunction: { select: 'id,name,method' },
            rpaAgent: { select: 'id,name' },
            rpaFlow: { select: 'id,name' },
            dynamicEntity: { select: 'id,displayName' },
          },
        },
        actionUserInstances: {
          select: 'id,operationType,observations,externalUserEmail,created',
          expand: {
            user: { select: 'fullname' },
          },
        },
        instanceApiCallResults: {
          select:
            'id,responseStatusCode,responseError,method,requestUrl,sentData,responseData,created',
        },
        instanceConsumeSequenceOperationResults: {
          select:
            'sequencePattern,sequenceItemPattern,generatedNumber,sequenceItemId,sequenceTraceId,created',
        },
        rpaCallResult: {
          select: 'sendStatus,sentData,responseStatus,responseData,responseError,created',
        },
        instanceDynamicEntityOperationResults: {
          select:
            'id,operation,operationItemsAffected,itemsAffected,mappingFilters,mappingTableFilters,insertItems,updateValues,response,isSuccessfullyOperation,created',
        },
      },
    },
    processInstanceApprovers: {
      select: 'id,externalUserEmail,approvalOrigin,parallelFlowInstanceId',
      expand: {
        user: { select: 'fullname' },
      },
    },
    commands: { select: '*' },
    parentProcessInstance: { select: 'id,name' },
    cancellationUser: { select: 'fullName' },
    voidedUser: { select: 'fullName' },
  },
};
